import axios from "axios";
import { API } from "@/lib/api";

// Public (no-auth) promo endpoints for the landing funnel.
export async function fetchActiveDeal() {
    const { data } = await axios.get(`${API}/billing/promo/active`);
    return data;
}

export async function submitLead(name, email) {
    const { data } = await axios.post(`${API}/billing/promo/lead`, { name, email });
    return data;
}

export function formatCountdown(secs) {
    const s = Math.max(0, Math.floor(secs || 0));
    const h = String(Math.floor(s / 3600)).padStart(2, "0");
    const m = String(Math.floor((s % 3600) / 60)).padStart(2, "0");
    const sec = String(s % 60).padStart(2, "0");
    return `${h}:${m}:${sec}`;
}

export const PROMO_KEY = "ww_promo";
export const getStoredPromo = () => sessionStorage.getItem(PROMO_KEY) || "";
export const setStoredPromo = (code) => {
    if (code) sessionStorage.setItem(PROMO_KEY, String(code).toUpperCase());
};
export const clearStoredPromo = () => sessionStorage.removeItem(PROMO_KEY);
